<div class="lpa-page-header">
  <div class="header-background">
    <div class="header-content">
      <div class="header-icon" *ngIf="icon">
        <i [class]="icon"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">{{ title }}</h1>
        <p class="page-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
        <p class="page-description" *ngIf="description">{{ description }}</p>
      </div>
    </div>
    <div class="header-accent"></div>
  </div>
</div>